export const regList = {
  phone: /^1([358][0-9]|4[01456879]|6[2567]|7[0135678]|9[012356789])[0-9]{8}$/,
  verification: /^[0-9]{6}$/,
  password: /^[A-Za-z0-9]{6,18}$/,
};
